export interface ImpersonatableUserDto {
  id: string;
  userName: string;
  name: string;
  surname: string;
  email: string;
  roles: string[];
  fullName?: string;
}

export interface ImpersonationStatusDto {
  isImpersonating: boolean;
  impersonatorUserId?: string;
  impersonatorUserName?: string;
  impersonatedUserId?: string;
  impersonatedUserName?: string;
  impersonatedUserFullName?: string;
  expiresAt?: string; // Comes as ISO string from API
}

export interface ImpersonationResultDto {
  success: boolean;
  errorMessage?: string;
  impersonatedUser?: ImpersonatedUserDto;
  expiresAt?: string; // Comes as ISO string from API
  impersonationToken?: string;
}

export interface ImpersonatedUserDto {
  id: string;
  userName: string;
  name: string;
  email: string;
}

export interface ImpersonationLogDto {
  id: string;
  impersonatorUserId: string;
  impersonatorUserName?: string;
  impersonatedUserId: string;
  impersonatedUserName?: string;
  startTime: Date;
  endTime?: Date;
  expiresAt: Date;
  ipAddress?: string;
  userAgent?: string;
  isActive: boolean;
  creationTime: Date;
  lastModificationTime?: Date;
}

export interface GetImpersonationLogsInput {
  impersonatorUserId?: string;
  impersonatedUserId?: string;
  startDate?: Date;
  endDate?: Date;
  skipCount?: number;
  maxResultCount?: number;
  sorting?: string;
}
